import {ACTION} from './constants';
import request from '../../../../utils/request';
import {formDataGenerator} from '../../../../utils/common';
import {requestConfig} from "../../../../config/apiResource";
import {hideMainLoader,showMainLoader} from "../../../actions";


export function getProductList(serverData,formData, isSearchAtion) {
    let ActionType, formDataValue,
    data={
        fund_type: '',
        categories: '',
        risk_profile: '',
        horizon:'',
        limit: 6,
        offset: 0,
        isFirstFav: 0,
    };
    if(!__CLIENT__){
        let queryParams;
        let goal_based =
            [
                'wealth-creation',
                'tax-savings',
                'childrens-fund',
                'retirement-planning',
                'regular-income',
            ]
        let path = serverData.queryString.split('/our-products/');
        if(path[1] && goal_based.includes(path[1])) {
            queryParams = {
                fund_type: path[1].replace(/-/g, ' ') || '',
            }
        }
        else {
            let catgr = path[1] ? path[1].replace(/-/g, ' ') : ''
            queryParams = {
                category: catgr,
            }
        }
        data["fund_type"]= queryParams.fund_type ? queryParams.fund_type : '';
        data["categories"]= queryParams.category ? queryParams.category : "";
        formData = formDataGenerator(data);
        formDataValue=formData;
        ActionType=isSearchAtion? ACTION.GET_SEARCH_LIST : ACTION.APPEND_PRODUCT_LIST;
    }
    else {
        formDataValue=formData;
        ActionType =  isSearchAtion? ACTION.GET_SEARCH_LIST : ACTION.APPEND_PRODUCT_LIST

    }
    return dispatch => {
        return request(requestConfig.getProductList(formDataValue))
            .then((json) => {
                // console.log(json.data.cards, 'json>>>////')
                json && dispatch({ type: ActionType , data: json.data });
                return json
            }).catch((error) => {
                console.log("Got Error with Product list data: " + error)
            });
    }
}


export function getProductCardNavContent(lang,nodeId) {
    return dispatch => {
        return request(requestConfig.getProductFundFactNavContent(lang,nodeId))
            .then((json) => {
                json && dispatch({ type: ACTION.GET_PRODUCT_CARD_NAV_CONTENT, data: json.data });
            }).catch((error) => {
                console.log(`Got Error with product id ${nodeId} fund fact NAV data: ${error}`)
            });
    }
}

export function clearProductList(lang,formData) {
    return {type: ACTION.CLEAN_PRODUCT_LIST}
}
export function getFiltersContent() {
    return dispatch => {
        return request(requestConfig.getProductFilters())
            .then((json) => {
                json && dispatch({ type: ACTION.GET_PRODUCT_FILTERS, data: json.data });
            }).catch((error) => {
                console.log("Got Error with Product filters data: " + error)
            });
    }
}

export function subscribeProduct(lang,formData, isProduct) {
    return dispatch => {
        return request(requestConfig.subscribeProduct(lang,formData, isProduct))
            .then((json) => {
                json && dispatch({ type: ACTION.POST_SUBSCRIBE_PRODUCT, data: json.data });
            }).catch((error) => {
                console.log("Got Error with subscribe product data: " + error)
            });
    }
}

export function postSmallCase(ticker) {
    return dispatch => {
        return request(requestConfig.postSmallCase(ticker))
            .then((json) => {
                json && dispatch({ type: "POST_SMALL_CASE", data: json.data });
                return json;
            }).catch((error) => {
                console.log("Got Error with subscribe product data: " + error)
            });
    }
}

export function postInvestDataETF(data) {
    return dispatch => {
        return request(requestConfig.postInvestDataETF(data))
            .then((json) => {
                json && dispatch({ type: "POST_INVEST_ETF", data: json.data });
            }).catch((error) => {
                console.log("Got Error with subscribe POST_INVEST_ETF data: " + error)
            });
    }
}

export function postSmallCaseID(data) {
    return dispatch => {
        return request(requestConfig.postSmallCaseID(data))
            .then((json) => {
                json && dispatch({ type: "POST_INVEST_ETF", data: json.data });
            }).catch((error) => {
                console.log("Got Error with subscribe POST_INVEST_ETF data: " + error)
            });
    }
}

export const clearSubscribeResult = () => {
    return {
        type: ACTION.CLEAR_SUBSCRIBE_RESULT
    }
}
//etf apis
export function getEtf() {
    return dispatch => {
        return request(requestConfig.getEtf())
            .then((json) => {
                json && dispatch({ type: ACTION.GET_ETF , data: json.data });
                return json;
            }).catch((error) => {
                console.log("Got Error with about us media video data: " + error)
            });
    }
}
